import React, { useEffect, type FC } from 'react'
import { useIntl } from 'react-intl'

import {
  GridCell,
  TooltipUtils,
  HelpIcon,
  Text,
  TEXT_VARIANT_SMALL_LIGHT,
} from 'mailup-web-components'
import {
  getActivityDataRetentionDaysUncapped,
  getTraceDataRetentionDaysCapped,
} from '../../utils/activitySpecValidation'

const ActivityRetentionText: FC = () => {
  const intl = useIntl()

  useEffect(() => {
    TooltipUtils.rebuild()
  }, [])

  const activityRetentionDays = getActivityDataRetentionDaysUncapped()
  const recipientsRetentionDays = getTraceDataRetentionDaysCapped()

  return (
    <GridCell span={12}>
      <Text variant={TEXT_VARIANT_SMALL_LIGHT}>
        {intl.formatMessage({ id: 'Load.Filters.DataRetentionWarning' })}{' '}
        <HelpIcon
          data-tip={intl.formatMessage(
            {
              id:
                activityRetentionDays >= 365
                  ? 'Load.CombinedFilterForm.DataRetentionDisclaimerNoExtension'
                  : 'Load.CombinedFilterForm.DataRetentionDisclaimer',
            },
            {
              activityRetentionDays,
              recipientsRetentionDays,
            },
          )}
        />
      </Text>
    </GridCell>
  )
}

export default ActivityRetentionText
